"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../helpers/time");
var BatchCreateService = /** @class */ (function () {
    function BatchCreateService(DrivesModel) {
        this.drive = null;
        this.DrivesModel = DrivesModel;
        this.momentIterate = this.momentIterate.bind(this);
        this.setDrive = this.setDrive.bind(this);
        this.getDrive = this.getDrive.bind(this);
    }
    BatchCreateService.prototype.setDrive = function (drive) {
        this.drive = drive;
        return this.drive;
    };
    BatchCreateService.prototype.getDrive = function () {
        return this.drive;
    };
    BatchCreateService.prototype.getCourse = function () {
        return this.course;
    };
    BatchCreateService.prototype.setCourse = function (course) {
        this.course = course;
    };
    BatchCreateService.prototype.getContext = function () {
        return this.context;
    };
    BatchCreateService.prototype.setContext = function (data) {
        this.context = data;
    };
    BatchCreateService.prototype.getBatchMethod = function (data, context) {
        switch (context) {
            case "drive":
                return this.DrivesModel.batchCreate(data);
                break;
            case "event":
                break;
            case "course":
                break;
        }
    };
    // http://stackoverflow.com/questions/22929204/iterate-throught-between-two-dates-in-javascript
    BatchCreateService.prototype.momentIterate = function (options, originalAppointment) {
        var drives = [];
        if (typeof options.days === "undefined") {
            options.days = {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
            };
        }
        var startDate = new Date(options.startDate);
        var endDate = new Date(options.endDate);
        var currentDate = new Date(startDate);
        while ((0, time_1.differenceInDays)(endDate, currentDate) >= 0) {
            var dayName = currentDate
                .toLocaleDateString("en-US", { weekday: "long" })
                .toLowerCase();
            if (typeof options.days[dayName] !== "undefined" &&
                options.days[dayName] === true) {
                var newDriveSession = Object.assign({}, originalAppointment);
                newDriveSession.formatDate = (0, time_1.toYMD)(currentDate);
                newDriveSession.formatTime = (0, time_1.formatDateTime)(originalAppointment.time, "HH:mm:ss").substring(0, 5);
                drives.push(newDriveSession);
            }
            currentDate.setDate(currentDate.getDate() + 1);
        }
        return drives;
    };
    BatchCreateService.prototype.getEvent = function () {
        return this.event;
    };
    BatchCreateService.prototype.setEvent = function (event) {
        this.event = event;
    };
    return BatchCreateService;
}());
BatchCreateService.$inject = ["DrivesModel"];
exports.default = BatchCreateService;
